import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BaseUrl } from "../Routes/BaseUrl";

export default function BlogData() {

    const { id } = useParams();
    const [data, setData] = useState({});

    const fetchCategory = async () => {
        const token = localStorage.getItem("token");
        console.log('token:', token);
        try {
            const response = await fetch(`${BaseUrl.trim()}/admin/blog/getSingle/${id}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`, // Include the token in the Authorization header
                    },
                }
            );
            const json = await response.json();
            setData(json.data);
            console.log("json:", json.data);
        } catch (e) {
            console.log("error fetching category...", e);
        }
    };

    useEffect(() => {
        fetchCategory();
    }, [id]);
    return (
        <div>
            <h2>{data.title}</h2>
            <div
                dangerouslySetInnerHTML={{ __html: data.content }}>
            </div>
        </div>
    )
}